import { jsx } from "react/jsx-runtime";
import { useClassName } from "@contember/react-utils";
import { memo, forwardRef } from "react";
import { Text } from "./Text.js";
import { toEnumViewClass } from "../../utils/toEnumViewClass.js";
const Heading = memo(forwardRef(({
  className,
  distinction,
  depth,
  size,
  ...headingProps
}, ref) => {
  const normalizedDepth = depth ?? 6;
  const headingElement = `h${normalizedDepth}`;
  return /* @__PURE__ */ jsx(
    Text,
    {
      as: headingElement,
      ref,
      className: useClassName("heading", [className, toEnumViewClass(size), toEnumViewClass(distinction)]),
      ...headingProps
    }
  );
}));
Heading.displayName = "Heading";
export {
  Heading
};
//# sourceMappingURL=Heading.js.map
